/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Card, InputFormGroup, colors, Button, useToast, Row, Column, DatePicker, Input, Select } from '@bonitour/components'
import { identity } from '@bonitour/common-functions'
import { string, date, object } from 'yup'
import { useValidateDateRange } from 'domains/CompanyReports/hooks/useValidadeDateRange'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

const button = css`
  height: 40px;
  width: 100%;
  margin-top: 20px;
`
const cardContrast = css`
  margin-bottom: 20px;
  padding: 15px;
  background-color: ${colors.gray13};
  border: none;
`

const width150 = css`
  width: 150px;
  width: 100%;
`

const RevenueFilterSchema = object().shape({
  initialDate: date().typeError('Deve ser uma data válida').required('A data inicial é obrigatória'),
  finalDate: date().typeError('Deve ser uma data válida').required('A data final é obrigatória'),
  fiscalDuty: string().nullable(),
  reservationCode: string().nullable(),
  payerName: string()
    .test({
      message: 'O nome do pagador deve ter no mínimo 3 caracteres',
      name: 'min',
      test: (value) => {
        if (!value) return true
        return value.length >= 3
      }
    }),
  fiscalDutyPresent: string().oneOf(['true', 'false', '']).nullable()
})

const filterFiscalDutyPresentOptions = [
  { value: '', label: 'Todos' },
  { value: 'true', label: 'Com nota fiscal' },
  { value: 'false', label: 'Sem nota fiscal' }
]

export const RevenueFilter = ({
  onFilterSubmit: emitFilterSubmit = identity,
  initialFilters = {}
}) => {
  const { add: addToast } = useToast()
  const {
    formState: {
      errors
    },
    handleSubmit,
    register,
    control
  } = useForm({
    resolver: yupResolver(RevenueFilterSchema),
    defaultValues: initialFilters
  })
  const { validateDateRange } = useValidateDateRange()

  const onError = () => addToast('Preencha o formulário corretamente')

  const validateFilters = (filters) => {
    validateDateRange(filters.initialDate, filters.finalDate) && emitFilterSubmit(filters)
  }

  const onClick = handleSubmit(validateFilters, onError)

  return (
    <Card css={cardContrast}>
      <Row>
        <Column phone={12} tabletlandscape={3} desktop={3}>
          <InputFormGroup label='Data inicial' errorMessage={errors.initialDate?.message}>
            <Controller
              name='initialDate'
              control={control}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  value={value}
                  onChange={onChange}
                  css={width150}
                  allowsEmpty
                />
              )}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} tabletlandscape={3} desktop={3}>
          <InputFormGroup label='Data final' errorMessage={errors.finalDate?.message}>
            <Controller
              name='finalDate'
              control={control}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  value={value}
                  onChange={onChange}
                  css={width150}
                  allowsEmpty
                />
              )}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} tabletlandscape={3} desktop={3}>
          <InputFormGroup label='Possui nota fiscal' errorMessage={errors.fiscalDutyPresent?.message}>
            <Controller
              name='fiscalDutyPresent'
              control={control}
              render={({ field: { onChange, value } }) => (
                <Select
                  placeholder='Todos'
                  options={filterFiscalDutyPresentOptions}
                  value={value}
                  error={errors.fiscalDutyPresent?.message}
                  onChange={onChange}
                />
              )}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} tabletlandscape={3} desktop={3}>
          <InputFormGroup label='Nota fiscal' errorMessage={errors.fiscalDuty?.message}>
            <Input
              onChangeWholeEvent
              error={errors.fiscalDuty?.message}
              {...register('fiscalDuty')}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} tabletlandscape={3} desktop={3}>
          <InputFormGroup label='Código da reserva' errorMessage={errors.reservationCode?.message}>
            <Input
              onChangeWholeEvent
              error={errors.reservationCode?.message}
              {...register('reservationCode')}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} tabletlandscape={3} desktop={3}>
          <InputFormGroup label='Nome do pagador' errorMessage={errors.payerName?.message}>
            <Input
              onChangeWholeEvent
              error={errors.payerName?.message}
              {...register('payerName')}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} tabletlandscape={3} desktop={3}>
          <Button css={button} onClick={onClick}>Pesquisar</Button>
        </Column>
      </Row>
    </Card>
  )
}
